import { render, staticRenderFns } from "./LessonsTree.vue?vue&type=template&id=3f666242&scoped=true&"
import script from "./LessonsTree.vue?vue&type=script&lang=ts&"
export * from "./LessonsTree.vue?vue&type=script&lang=ts&"
import style0 from "./LessonsTree.vue?vue&type=style&index=0&id=3f666242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f666242",
  null
  
)

export default component.exports